import React from 'react';

import {AlertActions, AlertModal} from 'presentation/components';
import {translations} from 'presentation/translations-new';

import {useChangeFlowDialog} from './hooks/useChangeFlowDialog';
import {ChangeFlowDialogProps} from './types';

const {cancel, confirm, notice, confirmProceed} = translations['pt-br'].commons;

export function ChangeFlowDialog({
	open,
	setOpen,
	setActiveBookingFlowStep,
	flowType,
	variant,
	modalDataTagId,
	cancelModalDataTagId,
	confirmModalDataTagId,
	closeModalDataTagId,
}: ChangeFlowDialogProps) {
	const {description, handleConfirm, handleClose} = useChangeFlowDialog({
		setActiveBookingFlowStep,
		flowType,
		variant,
		setOpen,
	});

	return (
		<AlertModal
			headerDataTagId={modalDataTagId}
			closeBtnDataTagId={closeModalDataTagId}
			footerContent={
				<AlertActions
					primaryAction={handleConfirm}
					secondaryAction={handleClose}
					secondaryText={cancel}
					primaryText={confirm}
					dataTagId={confirmModalDataTagId}
					secondaryBtnDataTagId={cancelModalDataTagId}
				/>
			}
			description={description}
			headerTitle={notice}
			onClose={() => setOpen(false)}
			title={confirmProceed}
			open={open}
			variant="primary"
		/>
	);
}
